import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "table-container" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "table-container" }


import NoData from '../../components/common/noData.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'vipTableView',
  props: {
    activeNo: {
        type: Number,
        required: true
    },
    tableData: {
        type: Array as () => any,
        required: false
    },
    activeData: {
        type: Object
    }
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (props.activeNo == 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_van_row, {
            class: "table-header",
            type: "flex",
            justify: "space-between"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: "4",
                class: "table-data"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.level')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: "4",
                class: "table-data"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('vip.bets')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: "4",
                class: "table-data"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('vip.upgradeBonus')), 1)
                ]),
                _: 1
              }),
              (__props.activeData?.isDailyReward === 1)
                ? (_openBlock(), _createBlock(_component_van_col, {
                    key: 0,
                    span: "4",
                    class: "table-data"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('vip.dailyBonus')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (__props.activeData?.isWeeklyRewards === 1)
                ? (_openBlock(), _createBlock(_component_van_col, {
                    key: 1,
                    span: "4",
                    class: "table-data"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('vip.weeklyBonus')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (__props.activeData?.isMonthlyRewards === 1)
                ? (_openBlock(), _createBlock(_component_van_col, {
                    key: 2,
                    span: "4",
                    class: "table-data"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('vip.monthlyBonus')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tableData, (item, index) => {
            return (_openBlock(), _createBlock(_component_van_row, {
              class: "table-row",
              key: index,
              type: "flex",
              justify: "space-between"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  span: "4",
                  class: "table-data",
                  style: {"color":"#ffb57fa6"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('vip.title')) + " " + _toDisplayString(item.level), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_van_col, {
                  span: "4",
                  class: "table-data"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.bet_min), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_van_col, {
                  span: "4",
                  class: "table-data"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.upgrade_bonus ? item.upgrade_bonus : '--'), 1)
                  ]),
                  _: 2
                }, 1024),
                (__props.activeData?.isDailyReward === 1)
                  ? (_openBlock(), _createBlock(_component_van_col, {
                      key: 0,
                      span: "4",
                      class: "table-data"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.daily_reward ?
                    item.daily_reward : '--'), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (__props.activeData?.isWeeklyRewards === 1)
                  ? (_openBlock(), _createBlock(_component_van_col, {
                      key: 1,
                      span: "4",
                      class: "table-data"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.week_reward ?
                    item.week_reward : '--'), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (__props.activeData?.isMonthlyRewards === 1)
                  ? (_openBlock(), _createBlock(_component_van_col, {
                      key: 2,
                      span: "4",
                      class: "table-data"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.month_reward ?
                    item.month_reward : '--'), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024))
          }), 128)),
          (props.tableData.length <= 0)
            ? (_openBlock(), _createBlock(NoData, { key: 0 }))
            : _createCommentVNode("", true)
        ])
      ]))
    : (props.activeNo == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_van_row, {
              class: "table-header",
              type: "flex",
              justify: "space-between"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  span: "4",
                  class: "table-data"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.level')), 1)
                  ]),
                  _: 1
                }),
                (__props.activeData?.isDailyReward === 1)
                  ? (_openBlock(), _createBlock(_component_van_col, {
                      key: 0,
                      span: "6",
                      class: "table-data"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('vip.dailyBonus')), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (__props.activeData?.isWeeklyRewards === 1)
                  ? (_openBlock(), _createBlock(_component_van_col, {
                      key: 1,
                      span: "8",
                      class: "table-data"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('vip.weeklyBonus')), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (__props.activeData?.isMonthlyRewards === 1)
                  ? (_openBlock(), _createBlock(_component_van_col, {
                      key: 2,
                      span: "6",
                      class: "table-data"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('vip.monthlyBonus')), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tableData, (item, index) => {
              return (_openBlock(), _createBlock(_component_van_row, {
                class: "table-row",
                key: index,
                type: "flex",
                justify: "space-between"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_col, {
                    span: "4",
                    class: "table-data",
                    style: {"color":"#ffb57fa6"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('vip.title')) + " " + _toDisplayString(item.level), 1)
                    ]),
                    _: 2
                  }, 1024),
                  (__props.activeData?.isDailyReward === 1)
                    ? (_openBlock(), _createBlock(_component_van_col, {
                        key: 0,
                        span: "6",
                        class: "table-data"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.daily_reward_retention), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true),
                  (__props.activeData?.isWeeklyRewards === 1)
                    ? (_openBlock(), _createBlock(_component_van_col, {
                        key: 1,
                        span: "8",
                        class: "table-data"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.week_reward_retention), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true),
                  (__props.activeData?.isMonthlyRewards === 1)
                    ? (_openBlock(), _createBlock(_component_van_col, {
                        key: 2,
                        span: "6",
                        class: "table-data"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.month_reward_retention), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024))
            }), 128)),
            (props.tableData.length <= 0)
              ? (_openBlock(), _createBlock(NoData, { key: 0 }))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
}
}

})